import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { selectCurrentUser } from '../store/user/selectors/user.selectors';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  protected store = inject(Store);
  protected router = inject(Router);
  protected log = inject(LoggerService);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): MaybeAsync<GuardResult> {
    return this.store.select(selectCurrentUser).pipe(
      map((user) => {
        this.log.debug(` Auth User ${!!user}`);
        if (!!user) {
          return true;
        }
        return this.router.createUrlTree(['/login']);
      }),
    );
  }
}

// canAtivate (store: Store, router: Router) {
//   return this.store.select(selectIsLoading).pipe(
//     skipWhile((isLoading) => isLoading),
//     take(1),
//     switchMap(() => store.select(selectIsAuthenticated)),
//     map((isAuthenticated) => {
//       if ( isAuthenticated ) {
//         return true;
//       }
//       return router.createUrlTree([ '/login' ]);
//     })
//   );
// }
